import { useEffect, useState } from "react";
import { Button, Flex, Loading, Text } from "@paguelofacil/pf-components";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";

import { language, languageDefault } from "../services/utils/Language";
import { getSessionCryptofacil, getUserCryptofacil } from "../services/utils/StorageUtils";

import LogoPfBill from "../assets/images/logo-pf-bills.svg";
import LogoZinli from "../assets/images/logo-zinli.svg";
import AppWithErrorBoundary from "../components/Error/ErrorBoudary";

import "../assets/scss/homecryptofacil.scss";
import "../assets/scss/home.scss";

const HomeCryptofacil = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);

    const onNavigate = path => {
        navigate(path);
    };

    useEffect(() => {
        const sessionCryptofacil = getSessionCryptofacil();
        const userCryptofacil = getUserCryptofacil();

        if (sessionCryptofacil && userCryptofacil) {
            return navigate("/cryptofacil/home");
        }
        setIsLoading(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <AppWithErrorBoundary>
            <Loading isLoading={isLoading}>
                <Flex direction="column" gap="2rem">
                    <Flex className="container-home-cryptofacil">
                        <Flex
                            direction="column"
                            align="center"
                            justify="center"
                            height="100%"
                            minW="auto"
                            className="container-box-init-cryptof"
                        >
                            <Flex
                                style={{ maxWidth: "55rem", padding: "1rem" }}
                                width="auto"
                                minW="none"
                                direction="column"
                                align="center"
                                justify="center"
                            >
                                <Text className="title-home-cryptofacil">
                                    <FormattedMessage
                                        id={language.title_home_cryptofacil}
                                        defaultMessage={languageDefault.title_home_cryptofacil}
                                    />
                                </Text>
                                <Text className="subtitle-home-cryptofacil">
                                    <FormattedMessage
                                        id={language.subtitle_home_cryptofacil}
                                        defaultMessage={languageDefault.subtitle_home_cryptofacil}
                                    />
                                </Text>
                            </Flex>
                            <Button
                                className="button-primary-cf button-init-cryptofacil"
                                size="md"
                                handleClick={() => onNavigate("/cryptofacil/login")}
                            >
                                <FormattedMessage id={language.login} defaultMessage={languageDefault.login} />
                            </Button>
                            <Button
                                className="button-transparent-cf button-init-cryptofacil"
                                size="md"
                                handleClick={() => onNavigate("/cryptofacil/signup")}
                            >
                                <FormattedMessage id={language.signup} defaultMessage={languageDefault.signup} />
                            </Button>
                        </Flex>
                        <img
                            src="https://assets.paguelofacil.com/images/widget/logo-cryptofacil-billscoins.webp"
                            alt="logo cryptofacil billscoins"
                            className="image-cryptofacil-billscoins"
                            loading="lazy"
                        />
                    </Flex>
                    <Flex
                        direction="row"
                        wrap="nowrap"
                        justify="center"
                        gap="0.5rem"
                        style={{ marginBottom: "1.5rem" }}
                    >
                        <Text variant="body5">
                            <FormattedMessage
                                id={language.our_partners}
                                defaultMessage={languageDefault.our_partners}
                            />
                        </Text>
                        <div className="icon-pf-partner">
                            <img src={LogoPfBill} alt="logo pf" loading="lazy" />
                        </div>
                        <div className="icon-zinli-partner">
                            <img src={LogoZinli} alt="logo pf" loading="lazy" />
                        </div>
                    </Flex>
                </Flex>
            </Loading>
        </AppWithErrorBoundary>
    );
};

export default HomeCryptofacil;
